export default __webpack_public_path__ + "static/media/art-4.abf8a5a3.png";